<template>
  <base-section
    id="info-alt"
    class="hh-keep"
    space="64"
  >
    <v-container>
      <v-row>
        <v-col
          v-for="item in items"
          :key="item.title"
          cols="12"
          sm="4"
        >
          <div class="hh-keep__title">
            {{ item.title }}
          </div>
          <a
            v-if="item.href"
            :href="item.href"
            class="hh-keep__value"
          >{{ item.text }}</a>
          <div
            v-else
            class="hh-keep__value"
          >
            {{ item.text }}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionKeepInTouch',

    data: () => ({
      items: [
        { title: 'Email', text: 'info@hackerhang.com', href: 'mailto:info@hackerhang.com' },
        { title: 'Based in', text: 'Melbourne, Florida' },
        { title: 'Working with', text: 'Clients across the US and remote worldwide' },
      ],
    }),
  }
</script>

<style lang="sass">
  .hh-keep
    border-top: 1px solid var(--hh-line)

    &__title
      color: var(--hh-muted)
      font-size: .9rem
      margin-bottom: 6px

    &__value
      font-size: 1.1rem
      color: var(--hh-text) !important
      text-decoration: none

    a.hh-keep__value:hover
      color: var(--hh-cyan) !important
</style>
